import { useState } from "react";

import {
  Button,
  Icon,
  Label,
  Modal,
  SelectAssignee,
} from "@web-app/components";

export default function AssignModal({
  initialAssigneeId,
  isBothIndividualAndRoutedOrderSelected,
  isRoutedOrderSelectedWithoutFullRoute,
  onAssign,
  onClose,
}: {
  initialAssigneeId?: string | null;
  isBothIndividualAndRoutedOrderSelected: boolean;
  isRoutedOrderSelectedWithoutFullRoute: boolean;
  onAssign: (assigneeId: string | null) => Promise<void>;
  onClose: () => void;
}) {
  const [selectedAssigneeId, setSelectedAssigneeId] = useState<string | null>(
    initialAssigneeId ?? null,
  );
  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = async () => {
    try {
      setIsLoading(true);
      await onAssign(selectedAssigneeId);
      setIsLoading(false);
      onClose();
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={
        <>
          <Icon name="circleExclamation" className=" text-red-600 mr-2" />
          Assign Orders
        </>
      }
      isOpen={true}
      onClose={onClose}
      noClose={true}
      width={400}
      actionsAlign="end"
      actions={[
        <Button plain onClick={onClose}>
          {!isBothIndividualAndRoutedOrderSelected &&
          !isRoutedOrderSelectedWithoutFullRoute
            ? "Cancel"
            : "Got it"}
        </Button>,
        !isBothIndividualAndRoutedOrderSelected &&
          !isRoutedOrderSelectedWithoutFullRoute && (
            <Button
              type="button"
              isLoading={isLoading}
              onClick={onConfirm}
              className="bg-black-600 hover:bg-black-700 text-white"
            >
              Confirm
            </Button>
          ),
      ]}
    >
      {isBothIndividualAndRoutedOrderSelected ? (
        <p className="text-sm font-normal leading-5 p-3">
          Bulk assign and send are not allowed for a combined selection of
          Routed and P2P orders. Please remove one to proceed.
        </p>
      ) : isRoutedOrderSelectedWithoutFullRoute ? (
        <p className="text-sm font-normal leading-5 p-3">
          Selection includes routed orders. Bulk assignment and send apply to
          full routes only.
        </p>
      ) : (
        <div className="p-3">
          <Label>Select Assignee</Label>
          <SelectAssignee
            selectedId={selectedAssigneeId}
            onChange={(assigneeId) => setSelectedAssigneeId(assigneeId)}
          />
        </div>
      )}
    </Modal>
  );
}
